<template>

  <table
      class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
    <tr>
      <th colspan="4">
        <h5 class="text-center"><b>Encaminhamentos</b></h5>
      </th>
    </tr>
    <tr>
      <td colspan="4">
        <load mode="table"
              v-if="loadingEncaminhamentos"/>
        <div class="col-md-12"
             v-else>

          <b-table
              :fields="[
                {
                  key: 'protocolo',
                  label: $t('Detalhes'),
                },
                {
                  key: 'created_at',
                  label: $t('Data'),
                },
          ]"
              :items="EncaminhamentosList"
              :responsive="true"
              striped
              hover
              show-empty
              small
              outlined
              stacked="xs"
              table-class="mb-3"
          >
            <template v-slot:cell(protocolo)="data">
              Usuário(s):<br/>
              <ul>
                <li
                    v-for="pessoa in data.item.usuarios"
                    :key="pessoa.id"
                >
                  <b>{{ pessoa.nome_completo }}</b>
                </li>
              </ul>
              Protocolo: <b>{{ data.item.protocolo }}</b>
              <br/>
              Tipo: <b>{{ data.item.tipo.descricao }}</b>
              <br/>
              Origem:
              <b v-if="data.item.unidade">{{
                  data.item.unidade.nome
                }}</b>
              <br/>
              Técnico: 
              <b>{{ data.item.tecnico.nome }}</b> - <span> {{ data.item.tecnico.profissao ?? 'Não informado' }} </span>

              <span v-if="data.item.unidade_destino">
                              <br/>
                              Unidade de Destino:
                              <b>{{ data.item.unidade_destino.nome }}</b>
                            </span>
              <span
                  v-if="data.item.unidade_externa"
                  class="text-muted text-xs"
              >
                              - Unidade Externa
                            </span>

            </template>
            <template v-slot:cell(created_at)="data">
              {{ data.item.created_at | formatDate() }}
            </template>


            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                />
                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "Encaminhamentos",
  props: ['familia'],
  data() {
    return {
      EncaminhamentosList: [],
      loadingEncaminhamentos: true,
    }
  },
  mounted() {
    this.getAtendimentos();
  },
  methods: {
    getAtendimentos() {

      this.loadingEncaminhamentos = true;
      axios
          .get(`api/dashboard/print/usuarios/encaminhamentos/${this.familia}`)
          .then((response) => {
            this.EncaminhamentosList = response.data.data;
            this.loadingEncaminhamentos = false;
          })
          .catch(() => {
            this.loadingEncaminhamentos = false;
          });
    },

  },
}
</script>

<style scoped>

</style>